module.exports = __webpack_public_path__ + "img/motorway_1x3_z18.c77776da.svg";